<template>
    <div>
        <div class="modal fade" id="modal-promotions" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">Promotion</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="row gy-3">
                            <template v-for="item in promotions">
                                <div :key="item.id" class="col-3" style="cursor: pointer"
                                    v-on:click="selectPromotion(item.id)">
                                    <div class="rounded-3 border d-flex align-items-center justify-content-center"
                                        style="height: 200px">
                                        <p class="text-center mb-0">{{ item.name }}</p>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modal-promotion-product-conditon" tabindex="-1" aria-labelledby="exampleModalLabel"
            data-bs-backdrop="static">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="d-flex flex-column m-3">
                        <div class="d-flex justify-content-between">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">
                                สินค้าที่เข้าร่วมโปรโมชัน(เงื่อนไข)
                            </h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div>
                            <p class="mb-0">{{ promotionDetail }}</p>
                        </div>
                        <hr />
                    </div>
                    <div class="modal-body">
                        <div class="row gy-3" style="max-height: 500px; overflow-y: scroll">
                            <template v-for="(item, i) in promotionProductConditions">
                                <div :key="'con' + i" class="col-4" style="cursor: pointer"
                                    v-on:click="selectPromotionProductCon(i)">
                                    <div :class="`rounded-3 p-2 border ${chosenPmtProductCon.includes(i) ? 'border-primary' : ''
                                        }`">
                                        <div class="text-end">
                                            <i class="fa fa-fw fa-exclamation-circle" :title="`วันหมดอายุ ${item.expiry_date ? item.expiry_date : '-'
                                                }\nลอต ${item.manufacturing_no ? item.manufacturing_no : '-'
                                                }`"></i>
                                        </div>
                                        <div style="height: 200px">
                                            <div class="text-center">
                                                <img class="mx-auto" style="height: 100px" :src="item.product_image"
                                                    alt="" />
                                            </div>
                                            <p class="text-center mb-0" style="height: 50px">
                                                {{ item.product_name }}
                                            </p>
                                            <div class="d-flex gap-2 align-items-baseline"
                                                v-if="chosenPmtProductCon.includes(i)">
                                                <span class="flex-33">MAX {{ item.amount }}</span>
                                                <input type="number" v-model="item.chosen_amount"
                                                    class="form-control form-control-sm text-end" v-on:click.stop />
                                                <span> {{ item.unit_name }} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" v-on:click="confirmPmtCon()">
                            ยืนยัน
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal-promotion-product-get" tabindex="-1" aria-labelledby="exampleModalLabel"
            data-bs-backdrop="static">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="d-flex flex-column m-3">
                        <div class="d-flex justify-content-between">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">
                                สินค้าที่เข้าร่วมโปรโมชัน(ได้รับ)
                            </h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div>
                            <p class="mb-0">
                                {{ promotionDetail }} จำนวน {{ max_taken }} ชิ้น
                            </p>
                        </div>
                        <hr />
                    </div>
                    <div class="modal-body">
                        <div class="row gy-3" style="max-height: 500px; overflow-y: scroll">
                            <template v-for="(item, i) in promotionProductGets">
                                <div :key="'get' + i" class="col-3" style="cursor: pointer"
                                    v-on:click="selectPromotionProductGet(i)">
                                    <div :class="`rounded-3 p-2 border ${chosenPmtProductGets.includes(i) ? 'border-primary' : ''
                                        }`">
                                        <div class="text-end">
                                            <i class="fa fa-fw fa-exclamation-circle" :title="`วันหมดอายุ ${item.expiry_date ? item.expiry_date : '-'
                                                }\nลอต ${item.manufacturing_no ? item.manufacturing_no : '-'
                                                }`"></i>
                                        </div>
                                        <div style="height: 200px">
                                            <div class="text-center">
                                                <img class="mx-auto" style="height: 100px" :src="item.product_image"
                                                    alt="" />
                                            </div>
                                            <p class="text-center mb-0" style="height: 50px">
                                                {{ item.product_name }}
                                            </p>
                                            <div class="d-flex gap-2 justify-content-around align-items-end"
                                                v-if="chosenPmtProductGets.includes(i)">
                                                <span>max:
                                                    {{
                                                        max_taken -
                                                        (!item.chosen_amount ? 0 : item.chosen_amount)
                                                    }}</span>
                                                <input type="number"
                                                    class="form-control form-control-sm text-end flex-33"
                                                    v-on:click.stop v-model="item.chosen_amount" />
                                                <span>{{ item.unit_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" v-on:click="confirmPmtGet()">
                            ยืนยัน
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modal-promotion-discount" tabindex="-1" aria-labelledby="exampleModalLabel"
            data-bs-backdrop="static">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="d-flex flex-column m-3">
                        <div class="d-flex justify-content-between">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">
                                สินค้าที่เข้าร่วมโปรโมชัน(ได้รับ)
                            </h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div>
                            <p class="mb-0">{{ promotionDetail }}</p>
                        </div>
                        <hr />
                    </div>
                    <div class="modal-body">
                        <div class="row gy-3" style="max-height: 500px; overflow-y: scroll">
                            <template v-for="(item, i) in promotionProductConditions">
                                <div :key="'dis' + i" class="col-3" style="cursor: pointer"
                                    v-on:click="selectPromotionProductCon(i)">
                                    <div :class="`rounded-3 p-2 border ${chosenPmtProductCon.includes(i) ? 'border-primary' : ''
                                        }`">
                                        <div class="text-end">
                                            <i class="fa fa-fw fa-exclamation-circle" :title="`วันหมดอายุ ${item.expiry_date ? item.expiry_date : '-'
                                                }\nลอต ${item.manufacturing_no ? item.manufacturing_no : '-'
                                                }`"></i>
                                        </div>
                                        <div style="height: 200px">
                                            <div class="text-center">
                                                <img class="mx-auto" style="height: 100px" :src="item.product_image"
                                                    alt="" />
                                            </div>
                                            <p class="text-center mb-0" style="height: 50px">
                                                {{ item.product_name }}
                                            </p>
                                            <div class="d-flex gap-2 justify-content-around align-items-end"
                                                v-if="chosenPmtProductCon.includes(i)">
                                                <span>max: {{ item.amount }}</span>
                                                <input type="number"
                                                    class="form-control form-control-sm text-end flex-33"
                                                    v-on:click.stop v-model="item.chosen_amount" />
                                                <span>{{ item.unit_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" v-on:click="confirmDiscount()">
                            ยืนยัน
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "found_promotion_id",
        "urlGetPromotion",
        "urlGetPromotionBuy",
        "urlCalPromotionDiscount",
        "urlCancelPromotion",
        "urlCalPromotionGet",
        "urlGetPromotionProductGet",
        "order_details",
    ],
    data() {
        return {
            promotions: [],
            chosenPromotion: null,
            promotionProductConditions: [],
            chosenPmtProductCon: [],
            promotionProductGets: [],
            chosenPmtProductGets: [],
            productUsageToConditions: [],
            max_taken: 0,
            step2: false,
        };
    },
    computed: {
        promotionDetail() {
            let promotion = this.promotions.find(
                (item) => item.id == this.chosenPromotion
            );
            return promotion ? promotion.detail : "";
        },
    },
    methods: {
        async managePromotion() {
            this.productUsageToConditions = [];
            this.promotionProductConditions = [];
            this.chosenPmtProductCon = [];
            this.promotionProductGets = [];
            this.chosenPmtProductGets = [];
            if (this.found_promotion_id.length <= 0) {
                return mySwal.fire({
                    title: "ไม่สามารถเพิ่มโปรโมชันได้",
                    text: "ไม่มีสินค้าในตะกร้าที่เข้าร่วมโปรโมชัน",
                    icon: "error",
                    confirmButtonText: "ตกลง",
                });
            }
            this.promotions = [];
            let res = await axios.get(this.urlGetPromotion, {
                params: {
                    promotion_ids: this.found_promotion_id,
                },
            });

            if (res.data.success) {
                this.promotions = res.data.promotions;
                $("#modal-promotions").modal("show");
            }
        },
        async selectPromotion(id) {
            this.chosenPromotion = id;
            $("#modal-promotions").modal("hide");

            let products = this.order_details.map((item) => {
                let productPackage = null;
                if (item.product_packages) {
                    productPackage = item.product_packages.find((p_item) => {
                        return p_item.id == item.product_package_id;
                    });
                }

                return {
                    product_id: item.product_id,
                    amount: item.amount,
                    product_package_id: item.product_package_id,
                    stock_transaction_id: item.stock_transaction_id,
                    product_name: item.product_name,
                    amount_per_unit: productPackage ? productPackage.amount_per_unit : 1,
                    product_image: item.product_image,
                    product_package_name: productPackage ? productPackage.name : null,
                    unit_name: item.smallest_unit,
                    expiry_date: item.expiry_date,
                    manufacturing_no: item.manufacturing_no,
                    promotion_id: item.promotion_id,
                    is_promotion: item.is_promotion,
                };
            });
            let res = await axios.post(this.urlGetPromotionBuy, {
                products,
                promotion_id: this.chosenPromotion,
            });
            if (res.data.success) {
                this.promotionProductConditions = res.data.cart;
                this.step2 = res.data.step2;
            }
            if (this.step2) {
                $("#modal-promotion-product-conditon").modal("show");
            } else {
                $("#modal-promotion-discount").modal("show");
            }
        },
        async confirmDiscount() {
            let chosen_products = this.chosenPmtProductCon.map((index) => {
                let item = this.promotionProductConditions[index];
                return {
                    index: index,
                    product_id: item.product_id,
                    amount: item.chosen_amount,
                    max_amount: item.amount,
                    stock_transaction_id: item.stock_transaction_id,
                    product_package_id: item.product_package_id,
                };
            });
            let error = chosen_products.find((item) => item.amount == undefined);
            if (error) {
                return mySwal.fire({
                    title: "กรอกข้อมูลไม่ครบถ้วน",
                    text: "กรุณากรอกจำนวนให้ครบถ้วน",
                    icon: "error",
                    confirmButtonText: "ตกลง",
                });
            }

            let error2 = chosen_products.find(item => Number(item.amount) > Number(item.max_amount))
            if (error2) {
                return mySwal.fire({
                    title: "กรอกข้อมูลไม่ถูกต้อง",
                    text: "จำนวนสินค้าน้อยกว่าที่เลือก",
                    icon: "error",
                    confirmButtonText: "ตกลง",
                });
            }
            this.$emit("calculate-discount", {
                promotionId: this.chosenPromotion,
                chosenProducts: chosen_products,
            });
        },
        async cancelPromotion() {
            let res = await axios.post(this.urlCancelPromotion);
            if (res.data.success) {
                this.$emit("cancel", {
                    cart: res.data.cart,
                    cart_details: res.data.calculated_cart,
                });
            }
        },
        async confirmPmtGet() {
            let chosen_products = this.chosenPmtProductGets.map((index) => {
                let item = this.promotionProductGets[index];
                return {
                    index: index,
                    product_id: item.product_id,
                    amount: item.chosen_amount,
                    max_amount: this.max_taken,
                    stock_transaction_id: item.stock_transaction_id,
                    product_package_id: item.product_package_id,
                };
            });
            let error = chosen_products.find((item) => item.amount == undefined);
            if (error) {
                return mySwal.fire({
                    title: "กรอกข้อมูลไม่ครบถ้วน",
                    text: "กรุณากรอกจำนวนให้ครบถ้วน",
                    icon: "error",
                    confirmButtonText: "ตกลง",
                });
            }
            this.$emit("calculate-get", {
                promotionId: this.chosenPromotion,
                chosenProducts: chosen_products,
                productUsages: this.productUsageToConditions
            });
        },
        selectPromotionProductGet(index) {
            let found = this.chosenPmtProductGets.findIndex((prev) => prev == index);
            if (found == -1) {
                this.chosenPmtProductGets.push(index);
            } else {
                this.chosenPmtProductGets.splice(found, 1);
            }
        },
        async confirmPmtCon() {

            let products = this.order_details.map((item) => {
                let productPackage = null;
                if (item.product_packages) {
                    productPackage = item.product_packages.find((p_item) => {
                        return p_item.id == item.product_package_id;
                    });
                }
                return {
                    product_id: item.product_id,
                    amount: item.amount,
                    product_package_id: item.product_package_id,
                    stock_transaction_id: item.stock_transaction_id,
                    product_name: item.product_name,
                    amount_per_unit: productPackage ? productPackage.amount_per_unit : 1,
                    product_image: item.product_image,
                    product_package_name: productPackage ? productPackage.name : null,
                    unit_name: item.smallest_unit,
                    expiry_date: item.expiry_date,
                    manufacturing_no: item.manufacturing_no,
                    in_p_condition: item.in_p_condition ? item.in_p_condition : 0,
                    is_promotion: item.is_promotion,
                    promotion_id: item.promotion_id
                };
            });

            let chosen_products = this.chosenPmtProductCon.map((index) => {
                let item = this.promotionProductConditions[index];
                return {
                    index: index,
                    product_id: item.product_id,
                    amount: item.chosen_amount,
                    stock_transaction_id: item.stock_transaction_id,
                    product_package_id: item.product_package_id,
                    max_amount: item.amount
                };
            });
            for (let i = 0; i < chosen_products.length; i++) {
                if (Number(chosen_products[i].amount) > Number(chosen_products[i].max_amount)) {
                    mySwal.fire({
                        title: "กรอกข้อมูลไม่ถูกต้อง",
                        text: "จำนวนสินค้าน้อยกว่าที่เลือก",
                        icon: "error",
                        confirmButtonText: "ตกลง",
                    });
                    return
                }
            }

            let error = chosen_products.find((item) => item.amount == undefined);
            if (error) {
                return mySwal.fire({
                    title: "กรอกข้อมูลไม่ครบถ้วน",
                    text: "กรุณากรอกจำนวนให้ครบถ้วน",
                    icon: "error",
                    confirmButtonText: "ตกลง",
                });
            }
            let res = await axios.post(this.urlGetPromotionProductGet, {
                promotion_id: this.chosenPromotion,
                products,
                chosen_products,
            });
            if (res.data.success) {
                this.productUsageToConditions = chosen_products;
                this.promotionProductGets = res.data.cart;
                this.max_taken = res.data.max_taken;
                $("#modal-promotion-product-conditon").modal("hide");
                $("#modal-promotion-product-get").modal("show");
            } else {
                mySwal.fire({
                    title: "เงื่อนไขโปรโมชัน",
                    text: "สินค้าที่เลือกไม่ครบตามเงื่อนไขโปรโมชัน",
                    icon: "error",
                    confirmButtonText: "ตกลง",
                });
                $("#modal-promotion-product-conditon").modal("hide");
            }
        },
        selectPromotionProductCon(index) {
            let found = this.chosenPmtProductCon.findIndex((prev) => prev == index);
            if (found == -1) {
                this.chosenPmtProductCon.push(index);
            } else {
                this.chosenPmtProductCon.splice(found, 1);
            }
        },
    },
};
</script>
